module.exports = __webpack_public_path__ + "img/dirt-6.092203b5.png";